import React from "react";
import Loader_1 from "../components/loaders/Loader-1";
import Loader_2 from "../components/loaders/Loader-2";
import Loader_3 from "../components/loaders/Loader-3";
import Loader_4 from "../components/loaders/Loader-4";
import Loader_5 from "../components/loaders/Loader-5";
import Loader_6 from "../components/loaders/Loader-6";
import Loader_7 from "../components/loaders/Loader-7";
import Loader_8 from "../components/loaders/Loader-8";
import Loader_9 from "../components/loaders/Loader-9";
import Loader_10 from "../components/loaders/Loader-10";
import Loader_11 from "../components/loaders/Loader-11";
import UpgradeCard1 from "../assets/img/upgrade-card/1.png";
import UpgradeCard2 from "../assets/img/upgrade-card/2.png";
import UpgradeCard3 from "../assets/img/upgrade-card/3.png";
import UpgradeCard4 from "../assets/img/upgrade-card/4.png";

const Test = () => {
  return (
    <>
      <div
        className="bg-white overflow-y-auto py-5
        d-flex flex-wrap justify-content-center align-items-center gap-3"
        style={{ width: "100vw", height: "100vh" }}
      >
        <div className="loader-test-box bg-white">
          <div className="h-100 d-flex justify-content-center align-items-center">
            <div className="fs-4 fw-bold top-0 pt-4 position-absolute">
              Loader_1
            </div>
            <Loader_1 />
          </div>
        </div>
        <div className="loader-test-box bg-white">
          <div className="h-100 d-flex justify-content-center align-items-center">
            <div className="fs-4 fw-bold top-0 pt-4 position-absolute">
              Loader_2
            </div>
            <Loader_2 />
          </div>
        </div>
        <div className="loader-test-box bg-dark">
          <div className="h-100 d-flex justify-content-center align-items-center">
            <div className="fs-4 fw-bold top-0 pt-4 position-absolute text-white">
              Loader_3
            </div>
            <Loader_3 />
          </div>
        </div>
        <div className="loader-test-box bg-white">
          <div className="h-100 d-flex justify-content-center align-items-center">
            <div className="fs-4 fw-bold top-0 pt-4 position-absolute">
              Loader_4_1
            </div>
            <Loader_4 type="web_vul" />
          </div>
        </div>
        <div className="loader-test-box bg-white">
          <div className="h-100 d-flex justify-content-center align-items-center">
            <div className="fs-4 fw-bold top-0 pt-4 position-absolute">
              Loader_4_2
            </div>
            <Loader_4 type="network_vul" />
          </div>
        </div>
        <div className="loader-test-box bg-white">
          <div className="h-100 d-flex justify-content-center align-items-center">
            <div className="fs-4 fw-bold top-0 pt-4 position-absolute">
              Loader_4_3
            </div>
            <Loader_4 cloud="aws" type="misconfig" />
          </div>
        </div>
        <div className="loader-test-box bg-white">
          <div className="h-100 d-flex justify-content-center align-items-center">
            <div className="fs-4 fw-bold top-0 pt-4 position-absolute">
              Loader_4_4
            </div>
            <Loader_4 cloud="aws" type="web_vul" />
          </div>
        </div>
        <div className="loader-test-box bg-white">
          <div className="h-100 d-flex justify-content-center align-items-center">
            <div className="fs-4 fw-bold top-0 pt-4 position-absolute">
              Loader_4_5
            </div>
            <Loader_4 cloud="aws" type="network_vul" />
          </div>
        </div>
        <div className="loader-test-box bg-white">
          <div className="h-100 d-flex justify-content-center align-items-center">
            <div className="fs-4 fw-bold top-0 pt-4 position-absolute">
              Loader_5
            </div>
            <Loader_5 />
          </div>
        </div>
        <div className="loader-test-box bg-dark">
          <div className="h-100 d-flex justify-content-center align-items-center">
            <div className="fs-4 fw-bold top-0 pt-4 position-absolute text-white">
              Loader_6
            </div>
            <Loader_6 />
          </div>
        </div>
        <div className="loader-test-box bg-dark">
          <div className="h-100 d-flex justify-content-center align-items-center">
            <div className="fs-4 fw-bold top-0 pt-4 position-absolute text-white">
              Loader_7
            </div>
            <Loader_7 />
          </div>
        </div>
        <div className="loader-test-box bg-dark">
          <div className="h-100 d-flex justify-content-center align-items-center">
            <div className="fs-4 fw-bold top-0 pt-4 position-absolute text-white">
              Loader_8
            </div>
            <Loader_8 />
          </div>
        </div>
        <div className="loader-test-box bg-white">
          <div className="h-100 d-flex justify-content-center align-items-center">
            <div className="fs-4 fw-bold top-0 pt-4 position-absolute">
              Loader_9
            </div>
            <Loader_9 />
          </div>
        </div>
        <div className="loader-test-box bg-white">
          <div className="h-100 d-flex justify-content-center align-items-center">
            <div className="fs-4 fw-bold top-0 pt-4 position-absolute">
              Loader_10
            </div>
            <Loader_10 />
          </div>
        </div>
        <div className="loader-test-box bg-dark">
          <div className="h-100 d-flex justify-content-center align-items-center">
            <div className="fs-4 fw-bold top-0 pt-4 position-absolute">
              Loader_11
            </div>
            <Loader_11 />
          </div>
        </div>

        <div className="d-flex justify-content-center align-items-center">
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ zoom: 0.6 }}
          >
            <img src={UpgradeCard1} alt="" />
          </div>
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ zoom: 0.6 }}
          >
            <img src={UpgradeCard2} alt="" />
          </div>
        </div>
        <div className="d-flex justify-content-center align-items-center">
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ zoom: 0.6 }}
          >
            <img src={UpgradeCard3} alt="" />
          </div>
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ zoom: 0.6 }}
          >
            <img src={UpgradeCard4} alt="" />
          </div>
        </div>
      </div>

      <style>
        {`
          .loader-test-box {
            position: relative;
            border-radius: 1em;
            // padding: 1em;
            width: 480px;
            height: 400px;
            border: 1px solid #ccc;
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
          }
        `}
      </style>
    </>
  );
};

export default Test;
